export default {
  state: {
    appSettings: {
      date: null,
      order_percent: null,
      refund_percent: null
    },
    appNewSettings: {
      date: null,
      order_percent: null,
      refund_percent: null
    }
  },
  mutations: {
    setAppSettings (state, payload) {
      state.appSettings = payload
    },
    setAppNewSettings (state, payload) {
      state.appNewSettings = payload
    }
  },
  actions: {
    getAppSettings ({commit, dispatch}) {
      const url = '/admin/settings/list?access_token=' + this.getters.accessToken
      dispatch('apiGet', url)
        .then((data) => {
          commit('setAppSettings', data.settings)
          commit('setAppNewSettings', data.new_settings)
        })
        .catch((error) => {
          throw error
        })
    },
    async updateAppSettings ({commit, dispatch}, appNewSettings) {
      let post = {
        data: {
          new_date: appNewSettings.date,
          new_order_percent: appNewSettings.order_percent,
          new_refund_percent: appNewSettings.refund_percent
        }
      }

      post.url = '/admin/settings/update?access_token=' + this.getters.accessToken
      dispatch('apiPost', post)
        .then((data) => {
          commit('setSuccess', 'Настройки обновлены')
        })
        .catch((error) => {
          throw error
        })
    }
  },
  getters: {
    appSettings (state) {
      return state.appSettings
    },
    appNewSettings (state) {
      return state.appNewSettings
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/settings.js